<template>
  <div>
    <v-breadcrumbs :items="breadcrumbItems" />

    <v-card>
      <v-data-table
        :headers="headers"
        :items="clients"
        :footer-props="footerProps"
        class="row-pointer"
        @click:row="displayDetails"
      >
        <template v-slot:item.userId="{ item }">
          <code>{{ userId(item) }}</code>
        </template>

        <template v-slot:item.name="{ item }">
          {{ userName(item) }}
        </template>

        <template v-slot:item.email="{ item }">
          {{ userEmail(item) }}
        </template>

        <template v-slot:item.socketId="{ item }">
          <code>{{ socketId(item) }}</code>
        </template>

        <template v-slot:item.address="{ item }">
          {{ address(item) }}
        </template>

        <template v-slot:item.transport="{ item }">
          <Transport
            v-if="item.sockets.length"
            :transport="item.sockets[0].transport"
          />
        </template>

        <template v-slot:item.sockets="{ item }">
          {{ item.sockets.length }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom v-if="isSocketDisconnectSupported">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click.stop="disconnect(item)"
                :disabled="isReadonly"
                small
                class="ml-3"
              >
                <v-icon>mdi-logout</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("clients.disconnect") }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SocketHolder from "../SocketHolder";
import Transport from "../components/Transport";

export default {
  name: "Clients",

  components: { Transport },

  data() {
    return {
      footerProps: {
        "items-per-page-options": [20, 100, -1],
      },
    };
  },

  computed: {
    breadcrumbItems() {
      return [
        {
          text: this.$t("clients.title"),
          disabled: true,
        },
      ];
    },
    headers() {
      return [
        {
          text: "#",
          value: "id",
          align: "start",
        },
        {
          text: "User ID",
          value: "userId",
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Socket ID",
          value: "socketId",
        },
        {
          text: "IP",
          value: "address",
        },
        {
          text: this.$t("sockets.transport"),
          value: "transport",
        },
        {
          text: this.$t("clients.sockets-count"),
          value: "sockets",
        },
        {
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    ...mapState({
      clients: (state) => state.main.clients,
      isReadonly: (state) => state.config.readonly,
      isSocketDisconnectSupported: (state) =>
        state.config.supportedFeatures.includes("DISCONNECT"),
    }),
  },

  methods: {
    firstSocket(client) {
      return client.sockets && client.sockets.length ? client.sockets[0] : null;
    },
    socketData(client) {
      const socket = this.firstSocket(client);
      return socket && socket.data ? socket.data : {};
    },
    userId(client) {
      const data = this.socketData(client);
      return data.userId || data.awsUid || "-";
    },
    userName(client) {
      return this.socketData(client).name || "-";
    },
    userEmail(client) {
      return this.socketData(client).email || "-";
    },
    socketId(client) {
      const socket = this.firstSocket(client);
      return socket ? socket.id : "-";
    },
    address(client) {
      const socket = this.firstSocket(client);
      return socket && socket.handshake ? socket.handshake.address : "-";
    },
    disconnect(client) {
      const socket = client.sockets[0];
      if (socket) {
        SocketHolder.socket.emit("_disconnect", socket.nsp, true, socket.id);
      }
    },
    displayDetails(client) {
      this.$router.push({ name: "client", params: { id: client.id } });
    },
  },
};
</script>

<style scoped>
.row-pointer >>> tbody > tr:hover {
  cursor: pointer;
}
</style>
